<template>
  <div class="row go-form-row flex-div go-common-drop-ctl">
    <go-label :labelAlign="labelAlign" :label="label" :item="item"></go-label>
    <div>
      <div class="ivu-upload ivu-upload-drag pull-left" style="width: 68px">
        <div style="height: 18px;line-height: 18px;">图标库</div>
        <div style="width: 68px;">
          <i
            class="ivu-icon ivu-icon-ios-image-outline"
            style="font-size:45px;"
          ></i>
        </div>
      </div>

      <div
        class="ivu-upload ivu-upload-drag  pull-left"
        style="width: 68px;margin-left:10px;"
      >
        <div style="height: 18px;line-height: 18px;">图片库</div>
        <div style="width: 68px;">
          <i
            class="ivu-icon ivu-icon-ios-image-outline"
            style="font-size: 45px;"
          ></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GoLabel from "../../../formVue/commponents/go-label";

export default {
    name: "go-img-sel-panel",
    data: function() {
        return {};
    },
    props: {
        labelAlign: {
            type: String,
            default: "right"
        },
        label: {
            type: String,
            default: "从库中选择"
        },
        icon: {
            type: Boolean,
            default: true
        },
        width: {
            type: [String, Number],
            default: "big"
        },
        value: {},
        item: {
            type: Object,
            default: () => {
                return {};
            }
        }
    },
    computed: {},
    mounted() {},
    methods: {},
    components: {
        GoLabel
    }
};
</script>



// WEBPACK FOOTER //
// goingsrc/vueCom/ctlVue/go-img-ctl/go-img-sel-panel/index.vue